import { Component, OnInit, Inject } from '@angular/core';
import { CouponService } from 'src/app/services/coupon.service';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { AccountService } from 'src/app/services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-push-coupon',
  templateUrl: './push-coupon.component.html',
  styleUrls: ['./push-coupon.component.css']
})
export class PushCouponComponent implements OnInit {
  coupon: any;
  checkconfirm: boolean;
  buttonDisabled = true;
  api_error: any;
  api_success: string;
  providerAlerts: any;
  Targetdomains: any;
  license_packages: any;
  domainNames: any[];
  subDomainNames: any[];
  licenseNames: any[];
  providers: any;
  constructor(private matDialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,
    private couponService: CouponService, private commonService: CommonfilterService, private accountService: AccountService) {
console.log(this.data);
    this.coupon = this.data;
    this.providers = this.coupon.target.providerId;
    this.commonService.getServiceSectors()
      .subscribe(res => {
        this.Targetdomains = res;
        if (this.coupon.target.domain) {
          if (this.coupon.target.domain.includes('ALL')) {
            this.domainNames = this.couponService.getAllDomains();
          } else {
            this.domainNames = this.couponService.getTargetedDomains(this.coupon.target.domain);
          }
        }
        if (this.coupon.target.subdomain) {
          if ((this.coupon.target.subdomain.includes('ALL')) && (this.coupon.target.domain.includes('ALL'))) {
            this.subDomainNames = this.couponService.getAllSubDomains();
          } else if ((this.coupon.target.subdomain.includes('ALL')) && (!this.coupon.target.domain.includes('ALL'))) {
            this.subDomainNames = this.couponService.getAllSubDomainNamesofDomain(this.coupon.target.domain);

          } else {
            this.subDomainNames = this.couponService.getTargetedSubDomainNames(this.coupon.target.subdomain);

          }
        }
        this.providerAlerts = this.coupon.providerDescription;
      });
    if (this.coupon.target.licenseRequired) {
      this.accountService.getLicensePackages()
        .subscribe(res => {
          this.license_packages = res;
          if (this.coupon.target.licenseRequired.includes(0)) {
            this.licenseNames = this.couponService.getAllLicenseNames(this.license_packages);
          } else {
            this.licenseNames = this.couponService.getLicenseNames(this.coupon.target.licenseRequired, this.license_packages);
          }
        });
    }
  }

  ngOnInit() {


  }
  checkConfirm() {
    if (this.checkconfirm === true) {
      this.buttonDisabled = false;
    } else {
      this.buttonDisabled = true;
    }

  }
  onPushConfirm() {
    const data = { 'message': this.providerAlerts };
    this.couponService.pushCoupon(this.coupon.jaldeeCouponCode, data)
      .subscribe(res => {
        this.api_success = 'Coupon pushed successfully';
        setTimeout(() => {
          this.matDialogRef.close();
        }, 2000);

      },
        (error) => {
          this.api_error = error.error;
        });
  }
}
